"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupReceivableBorrowingBaseTestWaivers = void 0;
/**
 * Takes an array of Db ReceivableBorrowingBaseTestWaiver entries
 * Returns a map of the waivers' propertyKey Sets grouped by finleyReceivableId
 */
const groupReceivableBorrowingBaseTestWaivers = ({ receivableBorrowingBaseTestWaivers, }) => {
    const groupedReceivableBorrowingBaseTestWaivers = {};
    receivableBorrowingBaseTestWaivers.forEach((waiver) => {
        const { finleyReceivableId, borrowingBaseTestKey } = waiver;
        if (!groupedReceivableBorrowingBaseTestWaivers[finleyReceivableId]) {
            groupedReceivableBorrowingBaseTestWaivers[finleyReceivableId] = new Set([
                borrowingBaseTestKey,
            ]);
        }
        else {
            groupedReceivableBorrowingBaseTestWaivers[finleyReceivableId].add(borrowingBaseTestKey);
        }
    });
    return groupedReceivableBorrowingBaseTestWaivers;
};
exports.groupReceivableBorrowingBaseTestWaivers = groupReceivableBorrowingBaseTestWaivers;
//# sourceMappingURL=receivableBorrowingBaseTestWaivers.js.map